import { IconPad } from '../IconPad';
import { StarIcon } from '../StarIcon';
import PropTypes from 'prop-types';
import React from 'react';

export const StarRating = ({ numStars }) => (
  <IconPad>
    {
      Array(parseInt(numStars)).fill(0).map((_, k) => <StarIcon key={k} />)
    }
  </IconPad>
);

StarRating.propTypes = {
  numStars: PropTypes.number.isRequired
};